// Review form in the owner-only LegalWatch report (templates/articles/legal-watch-status.ejs):
// a justification is required once an event gets a decision other than pending.
// The server checks the same rule (LegalWatchReviews.ts parseReviewForm).
export function initLegalWatchReview(form: HTMLFormElement): void {
    form.querySelectorAll<HTMLSelectElement>('[data-legal-watch-decision]').forEach((select) => {
        const note = select.closest('tr')!.querySelector<HTMLInputElement>('input[type="text"]')!;
        select.addEventListener('change', () => {
            note.required = select.value !== 'pending';
        });
    });
}
